module.exports = __webpack_public_path__ + "static/img/phone-2-doctors-patients-es.13cc8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone-2-doctors-patients-es.png
// module id = keYv
// module chunks = 0